import { useShouldShowSmsNotificationsPrompt } from '../../billing/hooks/useShouldShowSmsNotificationsPrompt';
import { SmsNotificationsPrompt } from '../../billing/components/SmsNotificationsPrompt';
import React from 'react';
import { ReleasePrompt } from '../../releaseprompt/components/ReleasePrompt';
import { ENV_E2E, readCommonConfig } from '../config';

export const OnStartModalPrompt = () => {
  const showReleasePromptOnStart = readCommonConfig().env !== ENV_E2E;
  const { setLastReminded } = useShouldShowSmsNotificationsPrompt();
  if (!!setLastReminded) {
    return <SmsNotificationsPrompt setLastReminded={setLastReminded} />;
  }
  return showReleasePromptOnStart ? <ReleasePrompt /> : null;
};
